import gql from 'graphql-tag'
export default gql`query attestsQuery {
  attests {
    attestNumber
    expirationDate
    id
  }
}`